import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45367c4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dk-stock-price__inner" }
const _hoisted_2 = { class: "dk-stock-price__content" }
const _hoisted_3 = { class: "dk-stock-price__date" }
const _hoisted_4 = { class: "dk-stock-price__last-price" }
const _hoisted_5 = { class: "dk-stock-price__label" }
const _hoisted_6 = { class: "dk-stock-price__value" }
const _hoisted_7 = { class: "dk-stock-price__change" }
const _hoisted_8 = { class: "dk-stock-price__label" }
const _hoisted_9 = { class: "dk-stock-price__isin" }

import { toRefs, computed } from 'vue';

import { LOCALE } from '@dormakaba/dormakaba-components/dist/types/lib/models/Locale';
import { DKStockPrice as DKStockPriceModel } from '@dormakaba/dormakaba-components/dist/types/lib/models/DKStockPrice';
import { DKProject } from '@/models/DKProjects';

interface Props {
  stockPrice: DKStockPriceModel;
  locale?: LOCALE;
  type?: DKProject;
}

enum StockPriceChangeValue {
  Positive = 'positive',
  Negative = 'negative',
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StockPrice',
  props: {
    stockPrice: {},
    locale: { default: 'en-US' },
    type: { default: DKProject.Country }
  },
  setup(__props: any) {

const props = __props;

const { stockPrice } = toRefs(props);

const isIn = computed<string>(() => stockPrice.value.isin);

const lastPrice = computed<string>(() =>
  parseFloat(`${stockPrice.value.last_price}`).toFixed(2)
);

const currency = computed<string>(() => stockPrice.value.currency);

const changeAbsolute = computed<number>(
  () => +stockPrice.value.change_absolute || 0
);

const changeRelative = computed<string>(
  () => stockPrice.value.change_relative || '0'
);

const priceChange = computed<string>(() => {
  const changeRelativePostfix = changeRelative.value.includes('%') ? '' : '%';
  const plusSign =
    changeValue.value === StockPriceChangeValue.Positive ? '+' : '';

  return `${currency.value} ${plusSign}${changeAbsolute.value.toFixed(
    2
  )} (${plusSign}${changeRelative.value}${changeRelativePostfix})`;
});

const changeValue = computed<StockPriceChangeValue | undefined>(() => {
  const options = {
    [StockPriceChangeValue.Negative]: changeAbsolute.value < 0,
    [StockPriceChangeValue.Positive]: changeAbsolute.value > 0,
  };

  return Object.keys(options).find(
    (key) => options[key as StockPriceChangeValue]
  ) as StockPriceChangeValue;
});

const dateTime = computed<string>(() => {
  const date = new Date(stockPrice.value.time_last_price * 1000);

  return date.toLocaleDateString(props.locale, {
    timeZone: 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['dk-stock-price', `dk-stock-price--${_ctx.type}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(dateTime.value) + " CEST", 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('footer.stock_price.last_price')), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(currency.value) + " " + _toDisplayString(lastPrice.value), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('footer.stock_price.change')), 1),
          _createElementVNode("p", {
            class: _normalizeClass([
              'dk-stock-price__value',
              { [`is-${changeValue.value}`]: changeValue.value },
            ])
          }, _toDisplayString(priceChange.value), 3)
        ]),
        _createElementVNode("div", _hoisted_9, "DOKA " + _toDisplayString(isIn.value), 1)
      ])
    ])
  ], 2))
}
}

})